import React from 'react';
import { Link } from 'react-router-dom';

const Navigation = ({ mode, onModeChange, scrolled }) => {
  return (
    <nav className={`nav-container ${scrolled ? 'scrolled' : ''}`} data-testid="navigation">
      <div className="nav-inner">
        <Link to="/" className="nav-logo" data-testid="nav-logo">AP.</Link>
        
        <div className="nav-center">
          <div className="mode-toggle" data-testid="mode-toggle">
            <button
              className={`toggle-btn ${mode === 'ux' ? 'active' : ''}`}
              onClick={() => onModeChange('ux')}
              data-testid="toggle-ux"
            >
              UX Design
            </button>
            <button
              className={`toggle-btn ${mode === 'photo' ? 'active' : ''}`}
              onClick={() => onModeChange('photo')}
              data-testid="toggle-photo"
            >
              Photography
            </button>
          </div>
        </div>
        
        <div className="nav-links">
          <a href="#work" className="nav-link" data-testid="nav-work">Work</a>
          <a href="#about" className="nav-link" data-testid="nav-about">About</a>
          <a href="#contact" className="nav-link" data-testid="nav-contact">Contact</a>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
